import { BulkImportRightPanel } from '@/components/bulk-import/BulkImportRightPanel';
import type { BulkImportRightPanelMode } from '@/types/bulkUserImport';
import type { BulkCredentialIssuePhase } from '@/components/bulk-import/BulkCredentialIssueFollowUp';
import type { BulkUserImportDraft } from '@/types/bulkUserImport';

export interface BulkReviewSurfaceProps {
  mode: BulkImportRightPanelMode;
  draft: BulkUserImportDraft;
  systemLabel: string;
  readOnly: boolean;
  tableMode: 'review' | 'post-import';
  uploadError: string | null;
  showApprove: boolean;
  approveDisabled: boolean;
  credentialIssuePhase: BulkCredentialIssuePhase | 'idle';
  credentialToastCount: number | null;
  onUploadFile: (file: File) => void;
  onUploadError: (message: string | null) => void;
  onRowUpdate: (rowId: string, patch: Partial<BulkUserImportDraft['rows'][number]>) => void;
  onApprove: () => void;
  onDismissCredentialToast: () => void;
  onIssueAllMobile: () => void;
  onIssueMobile: (row: BulkUserImportDraft['rows'][number]) => void;
  onClosePanel: () => void;
}

export function BulkReviewSurface({
  mode,
  draft,
  systemLabel,
  readOnly,
  tableMode,
  uploadError,
  showApprove,
  approveDisabled,
  credentialIssuePhase,
  credentialToastCount,
  onUploadFile,
  onUploadError,
  onRowUpdate,
  onApprove,
  onDismissCredentialToast,
  onIssueAllMobile,
  onIssueMobile,
  onClosePanel,
}: BulkReviewSurfaceProps) {
  return (
    <>
      {uploadError ? (
        <p className="bulk-import__upload-error" role="alert">
          {uploadError}
        </p>
      ) : null}
      <BulkImportRightPanel
        mode={mode}
        rows={draft.rows}
        fileName={draft.csvFileName}
        systemLabel={systemLabel}
        readOnly={readOnly}
        tableMode={tableMode}
        onUploadFile={onUploadFile}
        onUploadError={onUploadError}
        onRowUpdate={onRowUpdate}
        showApprove={showApprove}
        approveDisabled={approveDisabled}
        onApprove={onApprove}
        credentialIssuePhase={credentialIssuePhase}
        credentialToastCount={credentialToastCount}
        onDismissCredentialToast={onDismissCredentialToast}
        onIssueAllMobile={onIssueAllMobile}
        onIssueMobile={onIssueMobile}
        onClosePanel={onClosePanel}
      />
    </>
  );
}
